export default __webpack_public_path__ + "static/media/Votuza_California_Consumer_Privacy_Act.7d1895b6.pdf";